import { RouteApiUrl } from "../api.url";
import { GlobalAxios } from "../http";


export async function onGetRouteList() {
  return new GlobalAxios({
    axiosOptions: {
      url: RouteApiUrl.route
    },
    alertMsg: "获取 route 列表数据"
  }).fetch("GET")
}
